import { EoIntro } from "~/domains/commissioner/components/OnboardingWidget/types/EoIntro";
import { useIsNotebook } from "~/domains/common/hooks/mediaQueries";
import { useWelcomeWidget } from "./useWelcomeWidget";

function WelcomeWidget() {
  const isNotebook = useIsNotebook();
  const { userBrand, isOpen, handleCloseWidget, handleCreateContest } = useWelcomeWidget();

  if (!isOpen) return null;

  return (
    <EoIntro
      onCacClick={handleCreateContest}
      onClose={handleCloseWidget}
      brand={userBrand}
      isWide={!isNotebook}
    />
  )
}

export default WelcomeWidget;
